import React from "react";
import riseIcon from "./cnr_icon.png";
import cashIcon from "./cns_icon.png";
import tronIcon from "./trx_icon.png";
import centricLogo from "./centric_logo.png";
import centricLogoFull from "./centric_logo_white.svg";
import centricExplorerLogo from "./centric_explorer_logo.png";
import discord from "./discord_logo.png";
import telegram from "./telegram_logo.png";
import { TwitterCircleFilled, FacebookFilled } from "@ant-design/icons";
import "./Icons.scss";

function RiseIcon() {
  return <img src={riseIcon} className="Icon Icon__riseIcon" alt="" />;
}

function CashIcon() {
  return <img src={cashIcon} className="Icon Icon__cashIcon" alt="" />;
}

function TronIcon() {
  return <img src={tronIcon} className="Icon Icon__tronIcon" alt="" />;
}

function CentricLogo() {
  return (
    <img
      src={centricLogo}
      className="Icon Icon__centricLogo"
      alt="Centric Explorer"
    />
  );
}

const CentricLogoFull = () => (
  <img src={centricLogoFull} className="Logo__full" alt="Centric" />
);

function CentricExplorerLogo() {
  return (
    <img
      src={centricExplorerLogo}
      className="Icon Icon__centricLogo"
      alt="Centric Explorer"
    />
  );
}

function TelegramLogo() {
  return (
    <img
      src={telegram}
      className="Icon Icon__social Icon__telegram"
      alt="Telegram"
    />
  );
}

function DiscordLogo() {
  return (
    <img
      src={discord}
      className="Icon Icon__social Icon__discord"
      alt="Discord"
    />
  );
}

export default function ShowIcon({ icon }) {
  switch (icon) {
    case "rise":
      return <RiseIcon />;
    case "cash":
      return <CashIcon />;
    case "tron":
      return <TronIcon />;
    case "logo_text":
      return <CentricLogo />;
    case "logo_full":
      return <CentricLogoFull />;
    case "logo_explorer":
      return <CentricExplorerLogo />;
    case "twitter":
      return <TwitterCircleFilled className="Icon Icon__social" />;
    case "facebook":
      return <FacebookFilled className="Icon Icon__social" />;
    case "telegram":
      return <TelegramLogo />;
    case "discord":
      return <DiscordLogo />;
    default:
      return <img alt="" />;
  }
}
